import { useTranslation } from 'react-i18next';
import { useSnapshot } from 'valtio';

import { useTheme } from '@mui/material/styles';

import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { useBreakpoints } from '@/hooks';

import { ViewMode, store, toggleViewMode } from './store';

function ViewModeSwitch() {
  const theme = useTheme();
  const breakpoints = useBreakpoints();
  const { isMobileDevice, useUp } = breakpoints;
  const upSm = useUp('sm');

  const snap = useSnapshot(store);
  const { t } = useTranslation();
  const viewMode = snap.isAveragePowerMode
    ? ViewMode.CO2E
    : ViewMode.AVERAGE_POWER;

  const tooltipTitle = t(`viewMode.switchTo_${viewMode}`);

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Tooltip title={tooltipTitle}>
            <Switch
              color="secondary"
              checked={snap.isCO2eMode}
              onChange={toggleViewMode}
              sx={{ mr: 1 }}
            />
          </Tooltip>
        }
        labelPlacement="start"
        label={
          <Tooltip title={tooltipTitle}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              spacing={1}
              sx={{
                overflow: 'hidden',
              }}
            >
              {!isMobileDevice && (
                <Typography variant="subtitle1" textAlign="center">
                  {t(`viewMode.${snap.viewMode}`)}
                </Typography>
              )}
              <Typography
                variant="subtitle1"
                color="GrayText"
                noWrap
                sx={{ maxWidth: '100%' }}
              >
                {snap.viewModeUnit}
              </Typography>
            </Stack>
          </Tooltip>
        }
      />
    </FormGroup>
  );
}

export { ViewModeSwitch };
